import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { validatePermission } from 'actions/index';
import ApplicationLayout from 'v3/layouts/Application';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import Section from '../shared/Section';
import Data from '../shared/Data';
import RegisteredModal from './RegisteredModal';
import { useProduct } from '../shared/context';
import { handleCreation } from './controller';

export default function ProductRegister() {
  const navigate = useNavigate();
  const product = useProduct();

  const [showModal, setShowModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [hasPermissionToCreate, setPermissionToCreate] = useState(true);

  useEffect(() => {
    product.setData({
      id: null,
      name: null,
      productNcm: null,
      unit_measure: null,
      points: null,
      productType: null,
      ncm: null,
    });
    product.setErrors({});
  }, []);

  useEffect(() => {
    function validateProductPermission() {
      setPermissionToCreate(validatePermission('CADASTRAR_PRODUTOS'));
    }
    validateProductPermission();
  }, []);

  useEffect(() => {
    if (!hasPermissionToCreate) {
      product.showSnackbar('Você não tem permissão para criar produto', {
        type: 'error',
      });
      navigate('/');
    }
  }, [hasPermissionToCreate]);

  return (
    <>
      <ApplicationLayout
        title="Cadastrar produto"
        RightComponent={
          <>
            <Button
              variant="secondary"
              onClick={() => navigate('/produtos')}
            >
              <Text weight={500} color="black" type="regular">
                Voltar
              </Text>
            </Button>

            <Button
              variant="success"
              onClick={() => {
                handleCreation(
                  product.data,
                  product.setData,
                  product.setErrors,
                  product.showSnackbar,
                  setLoading,
                  setShowModal,
                );
              }}
              loading={isLoading}
            >
              <Text weight={500} color="white" type="regular">
                Salvar
              </Text>
            </Button>
          </>
        }
      >
        <RegisteredModal show={showModal} />
        <Row>
          <Col xs={12} md={6}>
            <Section Title="Dados do produto">
              <Data />
            </Section>
          </Col>
        </Row>
      </ApplicationLayout>
    </>
  );
}
